(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[616],{

/***/ 7805:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signup",
      function () {
        return __webpack_require__(4347);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* reexport */ Navbar_Navbar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 161 modules
var motion = __webpack_require__(2070);
// EXTERNAL MODULE: ./utils/AuthContext.tsx
var AuthContext = __webpack_require__(6864);
// EXTERNAL MODULE: ./components/Utils/Button.tsx
var Button = __webpack_require__(3091);
;// CONCATENATED MODULE: ./components/Navbar/Navbar.tsx






var Navbar = function(param) {
    var _handelScrollToContact = param.handelScrollToContact, handelScrollToContact = _handelScrollToContact === void 0 ? function() {} : _handelScrollToContact, _handelScrollToFeatures = param.handelScrollToFeatures, handelScrollToFeatures = _handelScrollToFeatures === void 0 ? function() {} : _handelScrollToFeatures, _handelScrollToPricing = param.handelScrollToPricing, handelScrollToPricing = _handelScrollToPricing === void 0 ? function() {} : _handelScrollToPricing;
    var router = (0,next_router.useRouter)();
    var ref = (0,AuthContext/* useUser */.a)(), user = ref.user, logOut = ref.logOut;
    var handleRouteToHome = function(anchor) {
        router.push("/?anchor=".concat(anchor));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "transition-all ease-in flex justify-between items-center py-4 px-8 max-w-6xl m-auto md:px-16 ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-6 md:gap-12",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-2 md:gap-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "dropdown",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        tabIndex: 0,
                                        className: "md:hidden",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "material-icons",
                                            children: "menu"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        tabIndex: 0,
                                        className: "menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                onClick: function() {
                                                    return router.pathname === "" ? handelScrollToFeatures() : handleRouteToHome("features");
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: "Features"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/formulas",
                                                    children: "Formulas"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                tabIndex: 0,
                                                onClick: function() {
                                                    return router.pathname === "" ? handelScrollToPricing() : handleRouteToHome("pricing");
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: "Pricing"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                onClick: function() {
                                                    return router.pathname === "" ? handelScrollToContact() : handleRouteToHome("contact");
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: "Contact"
                                                })
                                            }),
                                            user && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/dashboard",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: router.pathname === "/dashboard" ? "text-primary" : "",
                                                        children: "Dashboard"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: "flex items-center gap-4 text-lg md:text-xl md:font-bold ml-4 md:ml-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/graph.svg",
                                            alt: "logo",
                                            className: "h-8 w-8 md:h-12 md:w-12 "
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "hidden md:block",
                                            children: "AI Excel Bot"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden md:flex font-semibold",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "flex gap-8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    onClick: function() {
                                        return router.pathname === "" ? handelScrollToFeatures() : handleRouteToHome("features");
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "p-2 rounded-2xl duration-300 text-gray-500 hover:text-green-900 hover:bg-green-200",
                                        children: "Features"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/formulas",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "p-2 rounded-2xl duration-300 text-gray-500 hover:text-green-900 hover:bg-green-200",
                                            children: "Formulas"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    onClick: function() {
                                        return router.pathname === "" ? handelScrollToPricing() : handleRouteToHome("pricing");
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "p-2 rounded-2xl text-gray-500 duration-300 hover:text-green-900 hover:bg-green-200",
                                        children: "Pricing"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    onClick: function() {
                                        return router.pathname === "" ? handelScrollToContact() : handleRouteToHome("contact");
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "p-2 rounded-2xl text-gray-500 duration-300 hover:text-green-900 hover:bg-green-200",
                                        children: "Contact"
                                    })
                                }),
                                user && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/dashboard",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: "p-2 rounded-2xl text-gray-500 duration-300 hover:text-green-900 hover:bg-green-200",
                                                children: "Dashboard"
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center gap-2 md:gap-4",
                children: user ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    variant: "Large",
                    onClick: function() {
                        return logOut();
                    },
                    children: "Logout"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/signup",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "Large",
                                    children: "Signup"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/login",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.a */.E.a, {
                                className: "cursor-pointer px-3 py-1 md:px-6 md:py-3 font-semibold rounded-xl hover:bg-gray-200 duration-300 hover:text-black",
                                whileHover: {
                                    scale: 1.1
                                },
                                whileTap: {
                                    scale: 0.9
                                },
                                children: "Login"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Navbar_Navbar = (Navbar);

;// CONCATENATED MODULE: ./components/Navbar/index.ts



/***/ }),

/***/ 3091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2070);


var Button = function(param) {
    var children = param.children, _onClick = param.onClick, onClick = _onClick === void 0 ? function() {} : _onClick, _variant = param.variant, variant = _variant === void 0 ? "Default" : _variant, _loading = param.loading, loading = _loading === void 0 ? false : _loading, _loadingText = param.loadingText, loadingText = _loadingText === void 0 ? "Loading..." : _loadingText, _type = param.type, type = _type === void 0 ? "button" : _type;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_1__/* .motion.button */ .E.button, {
        type: type,
        className: "".concat(variant === "Default" ? "font-medium px-5 py-2.5" : "font-semibold px-6 py-3", " ").concat(loading ? "bg-green-600 cursor-not-allowed" : "bg-green-400 hover:bg-green-600 hover:text-white", " text-center text-sm rounded-xl duration-300 flex items-center"),
        whileHover: {
            scale: 1.1
        },
        whileTap: {
            scale: 0.9
        },
        onClick: onClick,
        disabled: loading,
        children: !loading ? children : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    "aria-hidden": "true",
                    role: "status",
                    className: "inline w-4 h-4 mr-3 text-white animate-spin",
                    viewBox: "0 0 100 101",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                            fill: "#E5E7EB"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                            fill: "currentColor"
                        })
                    ]
                }),
                loadingText
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 4347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(655);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_Navbar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9419);
/* harmony import */ var _components_Utils_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3091);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2962);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7294);
/* harmony import */ var _utils_AuthContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6864);










var SignUp = function() {
    var ref = (0,_utils_AuthContext__WEBPACK_IMPORTED_MODULE_7__/* .useUser */ .a)(), signUpWithEmailPassword = ref.signUpWithEmailPassword, authWithGoogle = ref.authWithGoogle;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(""), email = ref2[0], setEmail = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(""), password = ref3[0], setPassword = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(""), confirmPassword = ref4[0], setConfirmPassword = ref4[1];
    var handleSignupWithEmail = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(e) {
            var user, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        setLoading(true);
                        if (!(password !== confirmPassword)) return [
                            3,
                            1
                        ];
                        alert("Password and Confirm Password did not match.");
                        return [
                            3,
                            4
                        ];
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            signUpWithEmailPassword(email, password)
                        ];
                    case 2:
                        user = _state.sent();
                        if (user) {
                            window.gtag("event", "sign_up", {
                                "method": "Email"
                            });
                            setLoading(false);
                            router.push("/dashboard");
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.log(error);
                        alert("Error registering user." + error.message);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSignupWithEmail(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSignupWithGoogle = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            var user, error, error1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        user = null;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            authWithGoogle(false)
                        ];
                    case 2:
                        user = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.log(error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        if (user) {
                            window.gtag("event", "sign_up", {
                                "method": "Google"
                            });
                            router.push("/dashboard");
                        }
                        return [
                            3,
                            6
                        ];
                    case 5:
                        error1 = _state.sent();
                        console.log(error1);
                        alert("Error registering user." + error1.message);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSignupWithGoogle() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_3__/* .NextSeo */ .PB, {
                title: "Signup To AI Excel Bot",
                description: "AI Excel Bot helps you create complex Excel formulas in seconds. Use simple English prompts to generate formulas. AI Excel Bot's formula generator uses state of the art GPT-3 AI model to give you the best results.",
                canonical: "https://aiexcelbot.com/signup",
                openGraph: {
                    url: "https://aiexcelbot.com/signup",
                    title: "Signup To AI Excel Bot",
                    description: "AI Excel Bot helps you create complex Excel formulas in seconds. Use simple English prompts to generate formulas. AI Excel Bot's formula generator uses state of the art GPT-3 AI model to give you the best results.",
                    images: [
                        {
                            url: "https://aiexcelbot.com/dashboard-hero.png"
                        }
                    ],
                    siteName: "AI Excel Bot"
                },
                twitter: {
                    handle: "@0x_gautam",
                    cardType: "summary_large_image"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                className: "h-screen m-auto bg-green-50 scrollbar-thin scrollbar-thumb-gray-500 overflow-y-scroll overflow-x-hidden scrollbar-thumb-rounded-full scrollbar-track-rounded-full",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-6xl mx-auto",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Navbar__WEBPACK_IMPORTED_MODULE_1__/* .Navbar */ .w, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "p-6 space-y-4 md:space-y-6 sm:p-8",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                                className: "text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl ",
                                                children: "Create an account"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                className: "flex items-center justify-center w-full btn btn-outline",
                                                onClick: handleSignupWithGoogle,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        xmlnsXlink: "http://www.w3.org/1999/xlink",
                                                        className: "w-4 h-4 mr-2",
                                                        viewBox: "0 0 48 48",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                    id: "a",
                                                                    d: "M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                                                                id: "b",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("use", {
                                                                    xlinkHref: "#a",
                                                                    overflow: "visible"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                clipPath: "url(#b)",
                                                                fill: "#FBBC05",
                                                                d: "M0 37V11l17 13z"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                clipPath: "url(#b)",
                                                                fill: "#EA4335",
                                                                d: "M0 11l17 13 7-6.1L48 14V0H0z"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                clipPath: "url(#b)",
                                                                fill: "#34A853",
                                                                d: "M0 37l30-23 7.9 1L48 0v48H0z"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                clipPath: "url(#b)",
                                                                fill: "#4285F4",
                                                                d: "M48 48L17 24l-4-3 35-10z"
                                                            })
                                                        ]
                                                    }),
                                                    "Signup With Google"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                                                className: "space-y-4 md:space-y-6",
                                                onSubmit: handleSignupWithEmail,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                htmlFor: "email",
                                                                className: "label",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "label-text",
                                                                    children: "Your email"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                type: "email",
                                                                name: "email",
                                                                id: "email",
                                                                className: "input input-bordered w-full",
                                                                placeholder: "name@company.com",
                                                                onChange: function(e) {
                                                                    return setEmail(e.target.value);
                                                                },
                                                                required: true
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                htmlFor: "password",
                                                                className: "label",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "label-text",
                                                                    children: "Password"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                type: "password",
                                                                name: "password",
                                                                id: "password",
                                                                placeholder: "••••••••",
                                                                className: "input input-bordered w-full",
                                                                onChange: function(e) {
                                                                    return setPassword(e.target.value);
                                                                },
                                                                required: true
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                htmlFor: "confirm-password",
                                                                className: "label",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "label-text",
                                                                    children: "Confirm password"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                type: "confirm-password",
                                                                name: "confirm-password",
                                                                id: "confirm-password",
                                                                placeholder: "••••••••",
                                                                className: "input input-bordered w-full",
                                                                onChange: function(e) {
                                                                    return setConfirmPassword(e.target.value);
                                                                },
                                                                required: true
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "flex items-start",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "flex items-center h-5",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                    id: "terms",
                                                                    "aria-describedby": "terms",
                                                                    type: "checkbox",
                                                                    className: "checkbox checkbox-success",
                                                                    required: true
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "ml-3 text-sm",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                        htmlFor: "terms",
                                                                        className: "cursor-pointer label",
                                                                        children: [
                                                                            "I accept the",
                                                                            "  ",
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                                                href: "/terms-of-use",
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                                    className: "font-medium text-primary-600 hover:underline ml-2",
                                                                                    children: "Terms and Conditions"
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Utils_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                        type: "submit",
                                                        loading: loading,
                                                        children: "Create An Account"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                        className: "text-sm font-light text-gray-500",
                                                        children: [
                                                            "Already have an account?",
                                                            " ",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                                href: "/login",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                    className: "font-medium text-info-content hover:underline",
                                                                    children: "Login here"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (SignUp);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [664,70,962,774,888,179], function() { return __webpack_exec__(7805); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);